import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["snap-quote"]

  updateSnapQuotePackageInput(event) {
    const subCategory = event.params.subCategory
    this.snapQuoteOutlet.packageInputTarget.value = subCategory
  }
}
